import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
} from "firebase/auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { auth } from "../../firebase/firebase";

import "./Login.css";

function Login() {

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {

    e.preventDefault();

    setLoading(true);
    setError("");

    try {

      await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      navigate("/dashboard");

    } catch (err) {

      setError("Invalid Email or Password");

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="login-page">

      <div className="login-overlay">

        <div className="login-card">

          <div className="login-header">

            <h1>Sarrathi Constructions</h1>

            <p>Administration Portal</p>

          </div>

          <form onSubmit={handleLogin}>

            <div className="input-group">

              <label>Email Address</label>

              <input
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
                required
              />

            </div>

            <div className="input-group">

              <label>Password</label>

              <div className="password-input-wrap">

                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e)=>setPassword(e.target.value)}
                  required
                />

                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  tabIndex={-1}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>

              </div>

            </div>

            {error && (
              <p className="error-text">
                {error}
              </p>
            )}

            <button
              className="login-btn"
              disabled={loading}
            >

              {
                loading
                ? "Signing In..."
                : "Login"
              }

            </button>

          </form>

        </div>

      </div>

    </div>

  );

}

export default Login;